module.exports = __webpack_public_path__ + "img/PortadaND.a4381ee4.png";